import { render, staticRenderFns } from "./DeniedsList.vue?vue&type=template&id=c572ebe6&"
import script from "./DeniedsList.vue?vue&type=script&lang=js&"
export * from "./DeniedsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports